import { useEffect } from "react";

export interface UsePageViewParams {
  lookbookId: string;
  isPreviewMode: boolean;
}

export function usePageview(params: UsePageViewParams) {
  const { lookbookId, isPreviewMode } = params;

  useEffect(() => {
    if (typeof window !== "undefined" && !isPreviewMode) {
      const url = `/send/pageview/${lookbookId}`;

      try {
        navigator.sendBeacon(url);
      } catch {
        fetch(url, { method: "POST" });
      }
    }
  }, [lookbookId, isPreviewMode]);
}
